// Batch/exam pairing helpers.
//
// A quiz must be on the same exam its batch is preparing for; the server
// rejects a mismatch. These helpers let the launch dialogs narrow the choices
// so an owner never hits that error.

/**
 * Batches a quiz on `examId` may be assigned to.
 *
 * Batches created before the exam field existed have no exam and stay
 * selectable, since the server accepts them for any enrolled exam.
 */
export function batchesForExam(batches, examId) {
  const list = Array.isArray(batches) ? batches : [];
  if (!examId) return list;
  return list.filter((batch) => !batch?.examId || batch.examId === examId);
}

/** Exams a given batch can be assigned a quiz on. */
export function examsForBatch(exams, batch) {
  const list = Array.isArray(exams) ? exams : [];
  if (!batch?.examId) return list;
  return list.filter((exam) => (exam.examId || exam.id) === batch.examId);
}

/** Whether this pairing would be accepted. */
export function isBatchExamCompatible(batch, examId) {
  if (!batch) return false;
  if (!batch.examId) return true;
  return batch.examId === examId;
}

/** Suggested time limit for a quiz, matching the server's default. */
export function defaultDurationMinutes(questionCount) {
  const count = Number(questionCount);
  if (!Number.isFinite(count) || count <= 0) return 10;
  return Math.max(10, Math.round(count) * 2);
}
